import posthog from 'posthog-js';

let isInitialized = false;

export function markPosthogInitialized(): void {
  isInitialized = true;
}

export function capturePosthogEvent<TName extends string>(name: TName, properties?: Record<string, unknown>): void {
  if (!isInitialized) {
    console.warn(`PostHog event dropped before init: ${name}`);
    return;
  }
  try {
    posthog.capture(name, properties);
  } catch (error) {
    console.warn(`PostHog capture failed: ${name}`, error);
  }
}
